import * as moment from 'moment';
import * as Constants from '@/constants';
/* eslint-disable */

export default class {
  constructor(student) {
    const totalReimbursableMinutes = student.form.totalReimbursableMinutes;
    const serviceInfo = student.form.serviceInformation;
    const sessionDate = moment(serviceInfo.sessionDate, 'MM-DD-YYYY').format('YYYY-MM-DD');
    // validations will make sure medicaid exists if service delivered is reimbursable
    this.providerUserId = student.providerUserId;
    this.providerHUserId = student.providerHUserId;
    this.providerId = student.providerId;
    this.supportId = student.serviceId;
    this.supportTypeId = student.serviceTypeId;
    this.absentType = serviceInfo.absentType;
    this.absentReason = serviceInfo.absentReason;
    this.absentAlternative = serviceInfo.absentAlternative;
    this.absentAlternativeDesc = serviceInfo.absentAlternativeDesc;
    this.noServiceNotifFlag = serviceInfo.noServiceNotifFlag;
    this.groupSize = serviceInfo.groupSize;
    this.groupType = serviceInfo.groupType;
    this.credentialType = serviceInfo.credentialType;
    this.studentId = student.studentId;
    this.hStudentId = student.hStudentId;
    this.sessionDate = sessionDate;
    this.sessionTime = serviceInfo.sessionTime || null;
    this.sessionMinutes = serviceInfo.sessionMinutes ? Number(serviceInfo.sessionMinutes) : null;
    this.locationId = serviceInfo.location.locationId || null;
    this.locationOther = serviceInfo.locationOther || null;
    this.deliveryMode = serviceInfo.deliveryMode;
    this.serviceDelivered = serviceInfo.serviceDelivered;
    this.roomName = serviceInfo.roomName;
    this.progressAssessment = serviceInfo.progressAssessment;
    this.nextSessionFocus = serviceInfo.nextSessionFocus;
    this.nextSessionGoal = serviceInfo.nextSessionGoal;
    this.sessionNotes = serviceInfo.sessionNotes;
    this.studentBehavior = serviceInfo.studentBehavior;
    this.notes = serviceInfo.notes;
    this.objectiveNotes = serviceInfo.objectiveNotes;
    this.providerLocation = serviceInfo.providerLocation;
    this.licenseAttestDate = serviceInfo.licenseAttestDate;
    this.licenseAttestUserId = serviceInfo.licenseAttestUserId;
    this.licenseAttestName = serviceInfo.licenseAttestName;
    this.supervisorUserId = serviceInfo.supervisorUserId;
    this.supervisorName = serviceInfo.supervisorName;
    this.supervisorCredential = serviceInfo.supervisorCredential;
    this.supervisorDate = serviceInfo.supervisorDate;
    this.ptSessionBehaviors = serviceInfo.ptSessionBehaviors;
    this.ptSessionObjectives = serviceInfo.ptSessionObjectives;
    this.ptSessionProgresses = serviceInfo.ptSessionProgresses;
    /** TODO - TECHDEBT-4: Pattern for service implementation should be reviewed **/
    this.ptSessionObjectiveImplementation = serviceInfo.ptSessionObjectiveImplementation.slice(0, 3);
    // Clean up progress code values
    for (let i = 0; i < this.ptSessionProgresses.length; i++) {
      for (let j = this.ptSessionProgresses[i].measurable.length - 1; j >= 0; j--) {
        if (this.ptSessionProgresses[i].measurable[j].type === "OUT_OF" && this.ptSessionProgresses[i].measurable[j].value1 === '' && this.ptSessionProgresses[i].measurable[j].value2 === '') {
          // this.ptSessionProgresses[i].measurable.splice(j, 1);
        }
        else if (this.ptSessionProgresses[i].measurable[j].value1 === '') {
         // this.ptSessionProgresses[i].measurable.splice(j, 1);
        }
      }
    }

    for (let i = 0; i < this.ptSessionProgresses.length; i++) {
      for (let j = this.ptSessionProgresses[i].type.length - 1; j >= 0; j--) {
        // clear out unchecked values on edit (edits will have an id)
        // if (!this.ptSessionProgresses[i].type[j].checked && this.ptSessionProgresses[i].type[j].id) {
        if (!this.ptSessionProgresses[i].type[j].checked) {
          // this.ptSessionProgresses[i].type.splice(j, 1);
        }
      }
    }

    for (let i = 0; i < this.ptSessionProgresses.length; i++) {
      for (let j = this.ptSessionProgresses[i].assistance.length - 1; j >= 0; j--) {
        if (this.ptSessionProgresses[i].assistance[j].value1 && this.ptSessionProgresses[i].assistance[j].type === "NONE" ) {
          this.ptSessionProgresses[i].assistance[j].value1 = "none";
        }
        else if (!this.ptSessionProgresses[i].assistance[j].value1 && this.ptSessionProgresses[i].assistance[j].type === "NONE" ) {
          // this.ptSessionProgresses[i].assistance.splice(j, 1);
        }
        else if (this.ptSessionProgresses[i].assistance[j].type === "OUT_OF" && this.ptSessionProgresses[i].assistance[j].value1 === '' && this.ptSessionProgresses[i].assistance[j].value2 === '') {
          // this.ptSessionProgresses[i].assistance.splice(j, 1);
        }
        else if (this.ptSessionProgresses[i].assistance[j].value1 === '') {
          // this.ptSessionProgresses[i].assistance.splice(j, 1);
        }
      }
    }

    // unused field
    this.serviceDocumentation = null;
    // unused field
    this.hardToFill = null;
    this.verified = false;
    this.locId = null;
    this.rfpId = null;
    // clear out fields that aren't shown
    if (Constants.IS_ABSENT(serviceInfo.absentType)) {
      this.sessionTime = null;
      this.sessionMinutes = null;
      this.deliveryMode = null;
      this.serviceDelivered = null;
      this.roomName = null;
      this.providerLocation = null;
      this.groupType = null;
      this.groupSize = null;
      this.ptSessionBehaviors = null;
      this.ptSessionObjectives = null;
      this.ptSessionProgresses = null;
      this.ptSessionObjectiveImplementation = null;
      this.sessionNotes = null;
      this.nextSessionFocus = null;
      this.progressAssessment = null;
      this.nextSessionGoal = null;
    }
    if (serviceInfo.deliveryMode !== Constants.IN_PERSON) {
      this.roomName = null;
    }
    if (serviceInfo.deliveryMode !== Constants.TELEPRACTICE) {
      this.providerLocation = null;
    }
    // set medicaid information if it exists
    this.medicaid = Constants.IS_SD_REIMBURSABLE(serviceInfo.serviceDelivered) && totalReimbursableMinutes > 0;
    if (!Constants.IS_ABSENT(serviceInfo.absentType)) {
      this.medicaidMinutes = student.form.totalReimbursableMinutes;
      this.medicaidSessions = student.form.medicaid.map((procedure) => {
        return {
          ...procedure,
          studentId: student.studentId,
          hStudentId: student.hStudentId,
          providerUserId: student.providerUserId,
          providerHUserId: student.providerHUserId,
          procedureDate: sessionDate
        };
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/service-log-submission-class.js